import { COOKIE_POLICY_PROMPT_ACTION } from "store/actionTypes";

export const changeCookiePolicyPromptAction = (cookiePolicyPromptAction) => {
    return {
        type: COOKIE_POLICY_PROMPT_ACTION,
        payload: cookiePolicyPromptAction
    }
}

